<template>
<div>



<ContentHeader :title="$store.state.languages.lang_phrases.marka_kullanicilari"  url="CreateBrandUser" :show_button="showCreateNew" icon="plus" buttontype="primary" :label="$store.state.languages.lang_phrases.yeni_ekle"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>



<template v-if="!loading">
<template v-if="data.length==0">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">Henüz hiç kayıt oluşturulmamış</h3>

</div>
</template>
<template v-else>

<!--
<ContentTable :data="data" :columns="columns" routename="BrandUser" deleteobjectname="branduser" @dataDeleted="getData"  identifier_row_name="user_id"></ContentTable>
-->

<DataTable 
:value="data" 
class="p-datatable-suppliers" 
dataKey="id" 
responsiveLayout="scroll"
>



<template v-if="$store.state.auth.userroles.includes('admin') || this.is_editor_admin">

  <Column   :header="$store.state.languages.lang_phrases.isim"  sortable field="name" style="min-width: 8rem">
  <template #body="slotProps">
  <router-link class="text-primary p-link no-underline" :to="{ name: 'BrandUser' , params: { user_id: slotProps.data.id }}"><p>{{ slotProps.data.name}}</p></router-link>
  </template>
  </Column>
 
 <Column   :header="$store.state.languages.lang_phrases.email" >
  <template #body="slotProps">
  <p >{{slotProps.data.email}}</p>
  </template>
  </Column>

  <Column   :header="$store.state.languages.lang_phrases.yonetici" >
  <template #body="slotProps">
  <p v-html="$filters.booleanView( slotProps.data.is_admin)"></p>
  </template>
  </Column>

  <Column   :header="$store.state.languages.lang_phrases.projeler" >
  <template #body="slotProps">
    <template v-if=" slotProps.data.projects.length>1">
      <Tag 
      class="mr-2 mt-1 custom-chip"  
      v-tooltip.left="{ value:userProjects(slotProps.data.projects), disabled: false,class: 'custom-top-tooltip' }"
      :value="slotProps.data.projects[0].project.name+' +'+(slotProps.data.projects.length-1).toString()" 
      style="background-color:#352f8d"/>
      
    </template>
    <template v-else>

      <Tag 
      class="mr-2 mt-1 custom-chip" 
      v-for=" element in slotProps.data.projects"  
      :value="getTheTranslation(element.project,'translation')" 
      style="background-color:#352f8d"/>
    </template>
  
  </template>
  </Column>


  <Column headerStyle="width: 4rem; text-align: center" bodyStyle="text-align: center; overflow: visible">
  <template #body="{data}">
  <Button type="button"  icon="pi pi-ellipsis-h" @click="toggle($event,data.id)" aria-haspopup="true" :aria-controls="'overlay_menu'+data.id" class="p-button-primary p-button-text p-button-sm mt-1"   />
  <Menu :id="'overlay_menu'+data.id" :ref="'menu'+data.id" :model="menuitems" :popup="true">
  <template #item="{item}">  
  <a class="p-menuitem-link" role="menuitem" @click="item.command({id:data.id})">
  <span :class="'p-menuitem-icon '+item.icon"></span>
  <span class="p-menuitem-text">{{item.label}}</span>
  <span class="p-ink"></span></a>
  </template>
  </Menu>

  </template>
  </Column>



  

</template>
 



<template v-if="!$store.state.auth.userroles.includes('admin') && !this.is_editor_admin">
  <Column   :header="$store.state.languages.lang_phrases.isim"  sortable field="name" style="min-width: 8rem">
  <template #body="slotProps">
  <p class="text-primary">{{ slotProps.data.name}}</p>
  </template>
  </Column>

  <Column   :header="$store.state.languages.lang_phrases.projeler" >
  <template #body="slotProps">
  <Tag 
  class="mr-2 mt-1 custom-chip" 
  v-for=" element in slotProps.data.projects"  
  :value="element.project.name" 
  style="background-color:#352f8d"/>
  </template>
  </Column>

</template>










</DataTable>













</template>

</template>




</div>
</template>

<script>
export default {

  name: 'BrandUsers',

  data () {
    return {
      data:[],
      loading:true,
      is_editor_admin:null,
      menuitems: [
          {
              label: 'Görüntüle',
              icon: 'pi pi-eye',
              command: (id) => {
                  console.log("Görüntüle")
                  console.log(id)
                   this.$router.push({ name: 'BrandUser', params: { user_id:id.id } })
                  }
          },
          {
              label: 'Sil',
              icon: 'pi pi-trash',
              command: (id) => {
                  console.log(id)
                  this.deleteItem("branduser",id)
                  }
          }          
      ],
    }
  },
  mounted()
  {

    this.getData()
  },
  computed:{
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    },
    showCreateNew()
    {
      if(this.$store.state.auth.userroles.includes("admin"))
      {
        return true
      }
      if(this.$store.state.auth.userroles.includes("brand"))
      {
        if(this.is_editor_admin)
        {
          return true
        }
      }
      return false

    },
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
      if(newVal)
      {
        this.getData()
      }
    },
  },
  methods:{
    userProjects(projects)
    {
      let sttring = ""
      for (let i = 0; i < projects.length; i++)
      {
        if(i===0)
        {

          sttring = this.getTheTranslation(projects[i].project,"translation")
        }
        else
        {
          sttring = sttring+"\n"+this.getTheTranslation(projects[i].project,"translation")

        }
        
      }
      return sttring

    },
    toggle(event,id) 
    {
        this.$refs['menu'+id].toggle(event);
    },
    async getData()
    {
      this.is_editor_admin = await this.generalApiGetWithoutLoader("brand_user_is_admin")
      this.data = await this.generalApiGetWithoutLoader("brand/users/"+this.$route.params.id) 
      await console.log(this.data)
      this.loading = false

    },
    
  }
}
</script>

<style lang="css" scoped>
</style>